// extracted by mini-css-extract-plugin
export default {"dialog--wrapper":"siHGVVM3sr5IappTEEM8OzBwIw8rNmIQjbNd4ZMknGg="};